<template>
  <LineChartComponent
    :id="chartId"
    :options="options"
    :data="chartData"
    :styles="styles"
    :plugins="plugins"
  />
</template>

<script>
import { Line as LineChartComponent } from 'vue-chartjs';
import {
  Chart as ChartJS, Title, Tooltip, Legend, PointElement, LineElement, CategoryScale, LinearScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, PointElement, LineElement, CategoryScale, LinearScale);

export default {
  name: 'LineChart',
  components: {
    LineChartComponent,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    chartId: {
      type: String,
      required: true,
    },
    styles: {
      type: Object,
      default() {
        return {
          position: 'relative',
          width: '100%',
          height: '100%',
        };
      },
    },
    plugins: {
      type: Array,
      default() {
        return [{
          id: 'legendMargin',
          beforeInit(chart) {
            const fitValue = chart.legend.fit;

            // eslint-disable-next-line no-param-reassign
            chart.legend.fit = function fit() {
              fitValue.bind(chart.legend)();
              this.height += 24;
              return this.height;
            };
          },
        }];
      },
    },
  },
};
</script>
